import { Inject, Injectable } from '@angular/core';
import { GeneralService } from "../general.service";
import { HttpClient } from "@angular/common/http";
import { map, shareReplay } from "rxjs/operators";
import { Observable, of } from "rxjs";
import { StorageService } from '../storage.service';

@Injectable({
  providedIn: 'root'
})
export class PreferenceService extends GeneralService {
  cacheMap: { [key: string]: Observable<any> } = {};

  constructor(
    public http: HttpClient,
    private storageService: StorageService,
    @Inject('httpBaseSettings') public httpBaseSettings: any
  ) {
    super(http,httpBaseSettings);
    this.setModelPath('/ten/auth/preference');
  }

  saveColumnSettings(category, obj) {
    const requestObj = {
      category: category,
      subCategory: 'pickedColumns',
      preference: obj
    }
    return this.http.put(this.httpBase + '/ten/auth/preference', requestObj);
  }


  getColumnSettings(category) {
    // return this.http.get(this.httpBase + '/tenant/auth/preference/' + category + '/fullColumns')
    //   .pipe(map(res => res['data'] ? res['data']['preference'] : []));
    if (!this.cacheMap[category]) {
      this.cacheMap[category] = this.http.get('assets/columnSettings/' + category + '.json').pipe(shareReplay(1));
    }
    return this.cacheMap[category];
  }
  getPickedColumns(category): Observable<any> {
    return new Observable(observer => {
      this.http.get(this.httpBase + '/ten/auth/preference/' + category + '/pickedColumns')
        .pipe(map(res => res['data'] ? res['data']['preference'] : null)).subscribe(async res => {
          if (!res) {
            observer.next(await this.getColumnSettings(category).toPromise());
          } else {
            observer.next(res);
          }
        })
    });
    // return this.http.get(this.httpBase + '/tenant/auth/preference/' + category + '/pickedColumns')
    //   .pipe(map(res => res['data'] ? res['data']['preference'] : []));
  }
  //在制品报表-商品联动选择项
  getProductingReportItem(params) {
    return this.http.get(this.httpBase + '/ten/report/getProductingReportItem', { params }).pipe(map(res => res['data']));
  }
}
